export default import.meta.ROLLDOWN_FILE_URL_44zq6q3OBHe76m6OuK8k5Q